module["exports"] = [
  "####",
  "###",
  "##"
];
